var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    d: "M5.5 4.5h4.083c.23 0 .417.224.417.5s-.187.5-.417.5H5.5v4.083c0 .23-.224.417-.5.417s-.5-.187-.5-.417V5.5H.417C.187 5.5 0 5.276 0 5s.187-.5.417-.5H4.5V.417C4.5.187 4.724 0 5 0s.5.187.5.417V4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.fc482562cfe415421e8b17b73a4ba7ef.svg";
export { ForwardRef as ReactComponent };